import { render } from "./InPreparationOrders.vue?vue&type=template&id=2004bc06&scoped=true"
import script from "./InPreparationOrders.vue?vue&type=script&lang=js"
export * from "./InPreparationOrders.vue?vue&type=script&lang=js"

import "./InPreparationOrders.vue?vue&type=style&index=0&id=2004bc06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2004bc06"]])

export default __exports__